import { useCanceledOptions } from 'targets/web/modules/jobs/hooks/useCanceledOptions';

export const useDeclinedOptions = useCanceledOptions;
